module.exports = "/assets/_next/static/images/clouds-right-285cb7944e4e2275b2789959e476df56.png";